import http from "./http";
export default (costId) => ({
  async index(filters) {
    return http
      .index("costs", filters)
      .then((json) => ({ costs: json }))
      .catch(async (e) => ({ costs: null, error: await e }));
  },
  async sum(filters) {
    return http
      .index("costs/bills/sum", filters)
      .then((json) => ({ costs: json }))
      .catch(async (e) => ({ costs: null, error: await e }));
  },
  async get(filters) {
    return http
      .get("costs", costId, filters)
      .then((json) => ({ cost: json }))
      .catch(async (e) => ({ cost: null, error: await e }));
  },
  async create(data) {
    return http
      .post("costs", data)
      .then((json) => ({ cost: json }))
      .catch(async (e) => ({ cost: null, error: await e }));
  },
  async update(data) {
    return http
      .put("costs", costId, data)
      .then((json) => ({ cost: json }))
      .catch(async (e) => ({ cost: null, error: await e }));
  },
  async delete() {
    return http
      .delete("costs", costId)
      .then((json) => ({ cost: json }))
      .catch(async (e) => ({ cost: null, error: await e }));
  },
});
